import { IpData } from '../../models/IpData';
import { UseCase } from '../UseCase';
import { SessionRepository } from '../../repositories/SessionRepository';

export class GetIpUseCase implements UseCase<undefined, IpData>{

    constructor(private sessionRepo: SessionRepository) { }
    
    execute(t: undefined = undefined): Promise<IpData> {
        return this.sessionRepo.getIp();
    }

}